import { createPortal } from "react-dom";
import CoreBreadcrumb from "@/shared/navigation/breadcrumbs";
import { Link } from "react-router-dom";
import Text from "@/shared/typography/text";
import { HomeOutlined } from "@ant-design/icons";
import { useBreadcrumbs } from "../../utils/use-breadcrumbs";
import { BreadcrumbsOptions } from "../../models/types";
import { useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";

export const Breadcrumbs = function <T extends string>({
  breadcrumbsOptions,
}: {
  breadcrumbsOptions?: BreadcrumbsOptions<T>;
}) {
  const [mountNode, setMountNode] = useState<Element | null>(null);
  const { items } = useBreadcrumbs<T>(breadcrumbsOptions);

  useEffect(() => {
    const mountNode = document.querySelector(
      '[data-breadcrumbs-portal="breadcrumbs-portal"]',
    );

    if (mountNode) {
      setMountNode(mountNode);
    }
  }, []);

  if (!mountNode) {
    return null;
  }

  return createPortal(
    <CoreBreadcrumb
      className={twMerge(items.length === 0 && "invisible")}
      items={[{ title: <HomeOutlined />, href: "/" }, ...items]}
      itemRender={(route) => {
        return (
          <Link
            // max-w-full не даёт ссылке растянуться шире своей крошки, а сброс
            // отступов antd (padding 4px + margin -4px) убирает лишние 8px,
            // из-за которых текст обрезался бы даже когда он влезает
            className={"max-w-full !mx-0 !px-0"}
            to={route.href as string}
            title={typeof route.title === "string" ? route.title : undefined}
          >
            <Text color="white" className="ellipsis">
              {route.title}
            </Text>
          </Link>
        );
      }}
    />,
    mountNode,
  );
};
